export function createURL(str: string, q: Record<string, unknown> | undefined): URL {
  let url = str;
  if (q) {
    const params = mapValues(omitBy(q, isNil), (i) => String(i));
    if (Object.keys(params).length) {
      url = `${url}?${new URLSearchParams(params)}`;
    }
  }
  return new URL(url, window.location.origin);
}
